import { render, staticRenderFns } from "./ModalRenewal.vue?vue&type=template&id=79472488&"
import script from "./ModalRenewal.vue?vue&type=script&lang=js&"
export * from "./ModalRenewal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports